<template>
    <table class="trade-item-table" cellspacing="0" cellpadding="0">
        <thead>
            <tr>
                <th></th>
                <th>名稱</th>
                <th v-if="['invoiceSettings', 'payoutSettings', 'cInSettings', 'cOutSettings'].includes(dataType)">損益表</th>
                <th v-if="['cInElseSettings', 'cOutElseSettings'].includes(dataType)">財務分析表</th>
                <th v-if="dataType === 'childItems'">會計明細科目</th>
                <th v-if="dataType === 'childItems'">其他建議科目</th>
                <th></th>
            </tr>
        </thead>
        <draggable :value="value" tag="tbody" handle=".handle" animation="300" @start="onStart" @end="onEnd" @input="$emit('input', $event)">
            <tr v-for="(item, index) in value" :key="index" @click="onItemClick(item)" :class="{ active: selectedItemSno === item.iteM_NAM }">
                <td class="sort">
                    <div class="handle"></div>
                </td>
                <td class="name">
                    <span class="nam">{{ item.iteM_NAM }}</span>
                    <span class="mem">{{ item.grP_MEM }}</span>
                </td>
                <td v-if="['invoiceSettings', 'payoutSettings', 'cInSettings', 'cOutSettings'].includes(dataType)" class="sheet-item">
                    <el-select v-model="item.grP_NAM" placeholder="請選擇" size="mini" style="width: 128px" @change="$emit('grp-nam-change', $event, index)">
                        <el-option v-for="item in incomeStateSheetItems" :key="item.id" :label="`${item.id}. ${item.value}`" :value="item.id" :disabled="!isIncomeOptionUsable(item.id)"></el-option>
                    </el-select>
                </td>
                <td v-if="['cInElseSettings', 'cOutElseSettings'].includes(dataType)">
                    <el-select v-model="item.grP_NAM" placeholder="請選擇" size="mini" style="width: 128px" @change="$emit('grp-nam-change', $event, index)">
                        <el-option v-for="item in financeStatementList" :label="item.value" :value="item.id" :key="item.id"></el-option>
                    </el-select>
                </td>
                <td v-if="dataType === 'childItems'">{{ item.accno }} - {{ item.accnam }}</td>
                <td v-if="dataType === 'childItems'" class="suggested-acc-items">
                    {{ getSuggestedAccItemsTxt(item.suggestedAccItems) }}
                </td>
                <td class="edit">
                    <el-button size="mini" icon="el-icon-more" @click="onEdit($event, item, index)" />
                </td>
            </tr>
        </draggable>
    </table>
</template>
<script>
import { incomeStateSheetItems, financeStatementList } from '@/assets/commonData/options';
import draggable from 'vuedraggable';

export default {
    components: { draggable },
    props: {
        /*
        資料類型：
            invoiceSettings = 營業收入
            payoutSettings = 營業支出
            cInSettings = 營業其他收入
            cOutSettings = 營業其他支出
            cInElseSettings = 財務資產收入
            cOutElseSettings = 財務資產支出
            childItems = 子項目
        */
        dataType: {
            type: String,
            default: null,
        },
        value: {
            type: Array,
            default() {
                return [];
            },
        },
        selectedItemSno: {
            type: String,
            default: null,
        },
        isIncomeOptionUsable: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            incomeStateSheetItems,
            financeStatementList,

            isDragging: false,
        };
    },
    methods: {
        onItemClick(data) {
            this.$emit('itemClick', data);
        },
        onEdit(e, data, index) {
            e.preventDefault();
            e.stopPropagation();
            this.$emit('edit', data, index);
        },
        onStart() {
            this.isDragging = true;
        },
        onEnd() {
            this.$emit('dragged', this.value);
            this.isDragging = false;
        },
        getSuggestedAccItemsTxt(data) {
            const MAPPED = data.map((o) => `${o.accno} - ${o.accnam}`);
            return MAPPED.join(', ');
        },
    },
};
</script>
<style lang="scss">
.trade-item-table {
    width: 100%;

    th,
    td {
        padding: 4px 4px;
        font-size: 10pt;
        text-align: left;
        border-bottom: 1px solid #eee;
        cursor: default;
    }
    th {
        white-space: nowrap;
    }

    td {
        &.sort {
            width: 30px;
            .handle {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                width: 25px;
                height: 25px;
                border-radius: 2px;
                transition: 0.2s;

                &:after,
                &:before {
                    content: "";
                    width: 40%;
                    height: 1px;
                    margin: 1px 0;
                    background-color: #ccc;
                    transition: 0.2s;
                }

                &:hover {
                    background-color: #eee;
                    &:after,
                    &:before {
                        background-color: #444;
                    }
                }
            }
        }
        &.name {
            min-width: 150px;

            .mem {
                color: #aaa;
                font-size: 9pt;
                margin-left: 15px;
            }
        }
        &.sheet-item {
            width: 120px;
        }
        &.edit {
            width: 40px;
            text-align: center;
        }
    }
    tr:hover {
        td {
            background-color: #f7f8f9;
        }
    }
    tr.active {
        td {
            background-color: #f3f4fd;

            &.name {
                color: #443cab;
                font-weight: bold;
            }
        }
    }

    .suggested-acc-items {
        text-wrap: nowrap;
        overflow: hidden;
        max-width: 200px;
        text-overflow: ellipsis;
    }
}
</style>
